// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Gb-z","heading":"Hb-z"};